export interface FileRef {
  id: string;
  type: "file" | "url" | "base64";
  reference: string | File;
  name: string;
  ext: string;
  size: number;
}

export abstract class FileStorageContextPort {
  abstract set(ref: FileRef): FileRef;

  abstract get(id: string): FileRef | null;

  abstract del(id: string): void;

  abstract clear(): void;

}
